import { components } from '../api-abcscale';
import { apiPost, ApiCallbacks } from '../apiClient';

type ContactRequestDto = components['schemas']['ContactRequestDto'];

const CONTACT_URL = `${process.env.REACT_APP_ADMIN_API_BASE}/contact`;

export function sendContactForm(
  dto: ContactRequestDto,
  callbacks: ApiCallbacks<void>
): Promise<void> {
  return apiPost<void>(CONTACT_URL, dto, callbacks);
}
